<template>
  <tbody
    v-if="moduleColumns"
    :class="{'drag-top': toTopDrag, 'drag-bottom': toBottomDrag}"
    @dragover.prevent="dragModuleover($event)"
    @dragleave.prevent="dragModuleleave($event)"
  >
    <tr>
      <PricingSheetModuleNameCell
        :colspan="totalColumns"
        :name="module.name"
        :moduleKey="moduleKey"
        @dragStarted="$emit('dragModuleStarted', moduleKey)"
        @dragEnded="$emit('dragModuleEnded', moduleKey)"
        @dragOvered="$emit('dragModuleOvered', moduleKey)"
      >
      </PricingSheetModuleNameCell>
      <td class="empty-cell" :colspan="totalColumns-2">
        <div v-if="showPricesHours" class="hours-sum" :class="{'duplicate-sum': showPricesPrices}">{{ hoursSumModule(moduleKey) }}</div>
        <div v-if="showPricesPrices" class="hours-sum prices-sum" >{{ pricesSumModule(moduleKey) }}</div>
      </td>
    </tr>
    <tr v-for="(com, comkey) in module.components" :key="comkey" v-if="!com.hidden">
      <PricingSheetComNameCell
        :component="com"
        :moduleKey="moduleKey"
        :comKey="comkey"
        :isDragEnded="isDragEnded"
        :dragStartedKey="dragStartedKey"
        @dragStarted="$emit('dragComStarted', moduleKey, comkey)"
        @dragEnded="$emit('dragComEnded', moduleKey, comkey)"
        @dragOvered="$emit('dragComOvered', moduleKey, comkey)"
      >
      </PricingSheetComNameCell>
      <PricingSheetTextEditCell
         v-if="com.moduleColumns.metaElements && com.moduleColumns.metaElements.length"
         :key="'meta'+0"
         :moduleKey="moduleKey"
         :comKey="comkey"
         :cellKey="+0"
         :element="com.moduleColumns.metaElements[0]"
         :column="moduleColumns.metaElements[0]"
         :com="com"
         prefix="meta"
        class="desc-cell"
        textInput
      >
      </PricingSheetTextEditCell>
      <PricingSheetAttachmentCell
        v-if="com.moduleColumns.metaElements && com.moduleColumns.metaElements.length > 1"
        :key="'meta'+1"
        :moduleKey="moduleKey"
        :comKey="comkey"
        :cellKey="+1"
        :element="com.moduleColumns.metaElements[1]"
        :column="moduleColumns.metaElements[1]"
        :com="com"
        @previewImage="$emit('previewImage', {url: com.moduleColumns.metaElements[1].url, name: com.name})"
        prefix="meta"
        @dragStartAttachment="dragStartAttachment"
        @dragEndAttachment="dragEndAttachment"
        @dragOverAttachment="dragOverAttachment"
        class="desc-cell"
      >
      </PricingSheetAttachmentCell>
      <PricingSheetTextEditCell
         v-if="com.moduleColumns.metaElements && com.moduleColumns.metaElements.length > 1"
         :key="'meta'+2"
         :moduleKey="moduleKey"
         :comKey="comkey"
         :cellKey="+2"
         :element="com.moduleColumns.metaElements[2]"
         :column="moduleColumns.metaElements[2]"
         :com="com"
         :minValue = "+1"
         prefix="meta"
        class="desc-cell"
      >
      </PricingSheetTextEditCell>
      <PricingSheetTextEditCell
         v-if="com.moduleColumns.fixedElements && com.moduleColumns.fixedElements.length"
         v-for="(el, key) in com.moduleColumns.fixedElements"
         :key="'fixed'+key"
         :moduleKey="moduleKey"
         :comKey="comkey"
         :cellKey="key"
         :element="el"
         :column="moduleColumns.fixedElements[key]"
         :com="com"
         prefix="fixed"
         class="fixed-cell"
         :lastCell="
            key==com.moduleColumns.fixedElements.length-1 &&
            (!com.moduleColumns.hourlyElements || !com.moduleColumns.hourlyElements.length) &&
            (!com.moduleColumns.percentTasks || !com.moduleColumns.percentTasks.length)
         "
         :hoursSum="hoursSumComponent(com)"
         :priceSum="priceSumComponent(com)"
      >
      </PricingSheetTextEditCell>
      <PricingSheetTextEditCell
         v-if="com.moduleColumns.hourlyElements && com.moduleColumns.hourlyElements.length && !moduleColumns.hourlyElements[key].hidden"
         v-for="(el, key) in com.moduleColumns.hourlyElements"
         :key="'hourly'+key"
         :moduleKey="moduleKey"
         :comKey="comkey"
         :cellKey="key"
         :element="el"
         :column="moduleColumns.hourlyElements[key]"
         :com="com"
         prefix="hourly"
         :lastCell="
            key==com.moduleColumns.hourlyElements.length-1 &&
            (!com.moduleColumns.percentTasks || !com.moduleColumns.percentTasks.length)
         "
         :hoursSum="hoursSumComponent(com)"
         :priceSum="priceSumComponent(com)"
      >
      </PricingSheetTextEditCell>
      <PricingSheetTextEditCell
         v-if="com.moduleColumns.percentTasks && com.moduleColumns.percentTasks.length && !moduleColumns.percentTasks[key].hidden"
         v-for="(el, key) in com.moduleColumns.percentTasks"
         :key="'perchent'+key"
         :moduleKey="moduleKey"
         :comKey="comkey"
         :cellKey="key"
         :element="el"
         :column="moduleColumns.percentTasks[key]"
         :com="com"
         prefix="percent"
         class="percent-cell"
         :lastCell="key==com.moduleColumns.percentTasks.length-1"
         :hoursSum="hoursSumComponent(com)"
         :priceSum="priceSumComponent(com)"
      >
      </PricingSheetTextEditCell>
    </tr>
    <tr v-if="editable">
      <td
        class="text-left"
        colspan="2"
        :class="{'selected': selectNewRow}"
        @click="newRowClick()"
        @keydown.enter="addComponent()"
        tabindex="0"
        ref="newrow"
      >
        <div class="add-component">
          <img :src="staticImgPath+'Add-New-Row-Icon.png'" @click="addComponent()" class="curp"/>
          <span class="curp ml-40" v-on:click="addComponent()">New Row</span>
        </div>
      </td>
      <td class="desc-cell" v-for="(el, key) in moduleColumns.metaElements" :key="'m'+key"></td>
      <td class="fixed-cell" v-for="(el, key) in moduleColumns.fixedElements" :key="'f'+key">
        <div v-if="
              key==moduleColumns.fixedElements.length-1 &&
              (!moduleColumns.hourlyElements || !moduleColumns.hourlyElements.length) &&
              (!moduleColumns.percentTasks || !moduleColumns.percentTasks.length)
          "
         >
          <div v-if="showPricesHours" class="component-sum" :class="{'duplicate-sum': showPricesPrices}"></div>
          <div v-if="showPricesPrices" class="component-sum prices-sum"></div>
        </div>
      </td>
      <td class="desc-cell" v-for="(el, key) in moduleColumns.hourlyElements" :key="'h'+key" v-if="!el.hidden">
        <div v-if="
              key==moduleColumns.hourlyElements.length-1 &&
              (!moduleColumns.percentTasks || !moduleColumns.percentTasks.length)
          "
         >
          <div v-if="showPricesHours" class="component-sum" :class="{'duplicate-sum': showPricesPrices}"></div>
          <div v-if="showPricesPrices" class="component-sum prices-sum"></div>
        </div>
      </td>
      <td class="percent-cell" v-for="(el, key) in moduleColumns.percentTasks" :key="'element1'+key" v-if="!el.hidden">
        <div
          v-if="key==moduleColumns.percentTasks.length-1"
         >
          <div v-if="showPricesHours" class="component-sum" :class="{'duplicate-sum': showPricesPrices}"></div>
          <div v-if="showPricesPrices" class="component-sum prices-sum"></div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import PricingSheetTextEditCell from './PricingSheetTextEditCell'
import PricingSheetAttachmentCell from './PricingSheetAttachmentCell'
import PricingSheetModuleNameCell from './PricingSheetModuleNameCell'
import PricingSheetComNameCell from './PricingSheetComNameCell'
import { mapGetters } from 'vuex';
import PriceHelpers from '../../../../util/pricehelper';

export default {
  name: 'PricingSheetHead',
  data () {
    return {
      staticImgPath: "/images/",
      tempInput: "",
      toTopDrag: false,
      toBottomDrag: false,
      selectNewRow: false,
      dragOverAttachmentCell: null,
      draggingAttachmentUrl: null
    }
  },
  props: {
    module: {
      type: Object,
      required: true
    },
    moduleKey: {
      type: Number,
      required: true
    },
    isDragEnded: {
      type: Boolean,
      default: false
    },
    dragStartedKey: {
      defalut: {}
    },
    dragModuleStartedKey: {
      defalut: null
    }
  },
  components: {
    PricingSheetTextEditCell,
    PricingSheetAttachmentCell,
    PricingSheetModuleNameCell,
    PricingSheetComNameCell
  },
  methods: {
    temporaryInput() {},
    addComponent() {
      this.$store.dispatch('addNewComponent', {
        projectid: this.$route.params.projectid,
        moduleKey: this.moduleKey,
        comKey: this.module.components ? this.module.components.length : 0,
        name: 'New Deliverable'
      })
    },
    dragModuleover(e) {
      if (this.dragModuleStartedKey > this.moduleKey) {
        this.toTopDrag = true
      }
      if (this.dragModuleStartedKey < this.moduleKey) {
        this.toBottomDrag = true
      }
      this.$emit('dragModuleOvered', this.moduleKey)
    },
    dragModuleleave(e) {
      this.toTopDrag = false
      this.toBottomDrag = false
    },
    newRowClick() {
      this.$store.dispatch('updateSelectedCell', {
        moduleKey: this.moduleKey
      })
    },
    hoursSumModule (moduleKey) {
      const moduleSum = PriceHelpers.hoursOfModule(
          this.currentProjectModules[moduleKey],
          this.currentProjectModuleColumns,
          this.currentProjectRate
        )
      return moduleSum.toFixed(1)
    },
    pricesSumModule (moduleKey) {
      const moduleSum = PriceHelpers.priceOfModule(
        this.currentProjectModules[moduleKey],
        this.currentProjectModuleColumns,
        this.currentProjectRate
      )
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      return formatter.format(moduleSum)
    },
    hoursSumComponent (component) {
      return PriceHelpers.hoursOfCom(component, this.currentProjectModuleColumns)
    },
    priceSumComponent (component) {
      return PriceHelpers.priceOfCom(component, this.currentProjectModuleColumns, this.currentProjectRate)
    },
    dragStartAttachment(url) {
      this.draggingAttachmentUrl = url
    },
    dragEndAttachment(cellInf) {
      if (this.draggingAttachmentUrl && this.dragOverAttachmentCell) {
        this.$store.dispatch('updateAttachment', {
          projectid: this.$route.params.projectid,
          moduleKey: this.dragOverAttachmentCell.moduleKey,
          comKey: this.dragOverAttachmentCell.comKey,
          url: this.draggingAttachmentUrl
        })
        this.draggingAttachmentUrl = null
        this.dragOverAttachmentCell = null
      }
    },
    dragOverAttachment(cellInf) {
      this.dragOverAttachmentCell = cellInf
    }
  },
  computed: {
    ...mapGetters([
        'currentProjectModules',
        'selectedCell',
        'currentProjectRate',
        'currentProjectContingency',
        'currentProjectOverrides',
        'currentProjectModuleColumns',
        'showPricesPrices',
        'showPricesHours',
        'userRole'
      ]
    ),
    moduleColumns() {
      let moduleColumns = this.$store.getters.currentProjectModuleColumns
      if (moduleColumns) {
        moduleColumns.metaElements = moduleColumns.metaElements || []
        moduleColumns.fixedElements = moduleColumns.fixedElements || []
        moduleColumns.hourlyElements = moduleColumns.hourlyElements || []
        moduleColumns.percentTasks = moduleColumns.percentTasks || []
      }
      return moduleColumns;
    },
    totalColumns() {
      if (this.moduleColumns) {
        let count = !!this.moduleColumns.metaElements && this.moduleColumns.metaElements.length
          count += this.moduleColumns.fixedElements ? this.moduleColumns.fixedElements.length : 0
          count += this.moduleColumns.hourlyElements ? this.moduleColumns.hourlyElements.filter(el => !el.hidden).length : 0
          count += this.moduleColumns.percentTasks ? this.moduleColumns.percentTasks.filter(el => !el.hidden).length : 0
        return count + 2;
      }
      return 0;
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  watch: {
    selectedCell(data) {
      this.selectNewRow = data.moduleKey === this.moduleKey &&
        data.comKey === undefined &&
        data.cellKey === undefined &&
        data.prefix === undefined
      if (this.selectNewRow) {
        this.$refs.newrow.focus()
      }
    }
  },

  created () {

  },
  mounted() {}
}
</script>

<style scoped lang="scss">
@import "../../../../styles/components/_pricingsheet.scss";
.add-component {
  display: flex;
  color: #aaa;
  img {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 20px;
    top: 13px;
  }
  span {
    margin-left: 45px;
    font-size: 16px;
    font-family: "GG", sans-serif;
  }
}
.drag-bottom {
  border-bottom: 3px solid $highlightColor;
}
.drag-top {
  border-top: 3px solid $highlightColor;
}
.selected {
  border: 2px solid #f2397d !important;
}
.hours-sum {
  background-color: #5558FF !important;
  box-shadow: -7px 0 7px -7px rgba(139,139,139,0.5);
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100px;
  align-items: center;
  display: flex;
  color: white;
  font-size: 16px;
  font-weight: 500;
  padding-left: 16px;
}
.duplicate-sum {
  right: 130px !important;
}
.prices-sum {
  width: 130px !important;
}
</style>
